var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"welcome-container"},[_c('div',{staticClass:"bg"}),_c('el-row',{staticClass:"row"},[_c('el-col',{staticClass:"h1"},[_vm._v("暂未开放，敬请期待")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }